import FooterView from './components/FooterView';

export default FooterView;
